import React from 'react';
import PropTypes from 'prop-types';
import DropzoneComponent from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';

const accept = (name, fileTypes) => name.match(new RegExp('.*\\.(' + fileTypes.join('|') + ')$', 'i'));

const MediaUploader = ({fileTypes, onUploadDone, config}) => (
  <DropzoneComponent
    config={{
      iconFiletypes: fileTypes,
      showFiletypeIcon: true,
      postUrl: config.apiUrl + '/upload?project=' + config.getProjectKey(),
    }}
    djsConfig={{
      headers: {authorization: config.getAuthHeader()},
      autoProcessQueue: true,
      accept: ({name}, done) => (accept(name, fileTypes) ? done() : done('this filetype is not supported')),
    }}
    eventHandlers={{
      success: (response, data) => onUploadDone(data),
      //Todo: handle error
    }}
  />
);

MediaUploader.propTypes = {
  config: PropTypes.object.isRequired,
  fileTypes: PropTypes.array.isRequired,
  onUploadDone: PropTypes.func.isRequired,
};

export default MediaUploader;



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/MediaPicker/MediaUploader.js